module.exports = __webpack_public_path__ + "media/src/images/partners/salford-8a072688f8cd4005b7f6e90dcfa6b75d.jpg";